export function getMultiplierTierClass(m: number): string {
  if (m >= 10) return 'tier-epic';
  if (m >= 5) return 'tier-hot';
  if (m >= 2) return 'tier-warm';
  return 'tier-base';
}
